import React, { LabelHTMLAttributes } from "react";
import { GetLabelPropsOptions } from "downshift";
import classnames from "classnames";

import "./ComboboxLabel.scss";

interface ComboboxLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  getLabelProps: (options?: GetLabelPropsOptions) => any;
  ariaLabel?: string;
  value?: string;
}

export const ComboboxLabel = ({
  getLabelProps,
  ariaLabel,
  value,
}: ComboboxLabelProps) => {
  return (
    <label
      {...getLabelProps()}
      className={classnames("combobox__label", {
        "combobox__label--hidden": !value,
      })}
      aria-label={ariaLabel}
    >
      {value}
    </label>
  );
};
